import React from "react";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import WhatsappButton from "./components/WhatsappButton/WhatsappButton";
import Services from "./components/Services/Services";
import About from "./components/About/About";
import Achievements from "./components/Achievements/Achievements";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Achievements />
      <Footer />
      <WhatsappButton />
    </div>
  );
}

export default App;
